<template>
  <b-modal
    :id="'recall-notes-modal' + recall.id"
    :ref="'recall-notes-modal' + recall.id"
    modal-class="modal-fullscreen"
    centered
    no-close-on-backdrop
    scrollable
    title="Recall notes"
    size="lg"
    hide-footer
    @show="getRecallNotes()"
    @hidden="resetForm()"
  >
    <VehicleDetails
      v-if="vehicle"
      :vehicle="vehicle"
      :color="vehicle.vehicleInformation.color || '----'"
    />
    <NoteRegistrationForm
      v-if="userHasPermission('recall', 'write')"
      :vehicle="vehicle"
      :refreshData="getRecallNotes"
      :recall="recall"
    />
    <b-list-group v-if="!notes" class="mt-2">
      <b-list-group-item class="text-center">
        <b-spinner variant="yellow" />
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-else class="mt-2 mb-2 note-list" tag="ul">
      <b-list-group-item v-if="notes && !notes.length" class="text-center">
        <b>No notes to show</b>
      </b-list-group-item>

      <b-list-group-item
        v-for="(note, i) in notes"
        :key="i"
        class="flex-column align-items-start"
        tag="li"
      >
        <NoteCard :note="note" :refreshData="getRecallNotes" />
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { GET_RECALL_NOTES } from "./actions";
import { superAdminMixin } from "@/modules/superAdmin/mixins.js";
import NoteRegistrationForm from "./RegistrationForm";
import VehicleDetails from "@/modules/superAdmin/components/VehicleDetails.vue";
import NoteCard from "./NoteCard.vue";
export default {
  name: "RecallNotesModal",
  components: { NoteRegistrationForm, VehicleDetails, NoteCard },
  mixins: [superAdminMixin],
  props: ["recall"],
  computed: {
    ...mapState({
      vehicle: (state) => state.superAdminStore.vehicle,
      /*   notes: (state) => state.vehicle.recall.notes.notes, */
    }),
  },
  data() {
    return {
      notes: null,
    };
  },
  mounted() {},
  methods: {
    resetForm() {},
    changePage(page) {
      this.$store.commit(GET_RECALL_NOTES, {
        fields: { page },
      });
      this.getNotes();
    },
    getRecallNotes() {
      this.$store
        .dispatch(GET_RECALL_NOTES, {
          id: this.recall.id,
        })
        .then((response) => {
          this.notes = [];
          this.notes = response.recallNote;
          this.$parent.getRecallNotes();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.resize-none {
  resize: none;
}
.note-list {
  max-height: 500px;
  overflow-y: auto;
}
</style>
